import moment from 'moment'
import React from 'react'
import logo from '../zigloi.png'
import footerDot from './footerdots.png'

export const Footer = () => {
    return (
        <div>
             <div class="have-questions-section mb--70--145">
        <div class="container">
            <div class="have-question-wrapper">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="have-question-content">
                            <h2 class="title">Still Have Questions?</h2>
                            <p>Our customer care team is here for you!</p>
                            <a href="#/contact" class="custom-button">Contact Us</a>
                        </div>
                    </div>
                    <div class="right-thumb d-none d-lg-block">
                        <img src="./assets/images/faq/have-questions.png" alt="faq"/>
                    </div>
                </div>
            </div>
        </div>
    
        </div>
        <footer class="footer-section pt-70-145">
        <div class="dot-slider bg_img" data-background={footerDot}></div>
        <div class="container">
            <div class="footer-top cl-white padding-bottom padding-top">
                <div class="row mb--50 justify-content-between">
                    <div class="col-sm-8 col-lg-4">
                        <div class="footer-widget widget-about">
                            <div class="logo-area">
                                <div class="logo">
                                    <a href="#/"><img src={logo} alt="logo"/></a>
                                </div>
                               
                            </div>
                            {/* <ul class="social-icons">
                                <li>
                                    <a href="#0"><i class="fab fa-facebook-f"></i></a>
                                </li>
                                <li>
                                    <a href="#0" class="active"><i class="fab fa-pinterest-p"></i></a>
                                </li>
                                <li>
                                    <a href="#0" class=""><i class="fab fa-twitter"></i></a>
                                </li>
                                <li>
                                    <a href="#0"><i class="fab fa-instagram"></i></a>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                    <div class="col-sm-8 col-md-8 ">
                        {/* <div class="footer-widget widget-link"> */}
                            <h5 class="title">Zigloi Support</h5>
                            <br></br>
                            <p>Zigloi support is a Support & Help Center  to create your own 24/7 self-service customer support center.</p>
                            <p>
                                <br></br>
                                <p>Contact by Phone</p>
                                <h4>+233545905150 / +233505866057 / +233575908638</h4>
                            </p>
                        {/* </div> */}
                    </div>
                    {/* <div class="col-sm-8 col-lg-4">
                        <div class="footer-widget widget-newsletter">
                            <h5 class="title">Newsletter</h5>
                            <form class="newsletter-form">
                                <input type="text" placeholder="Enter Your Email" name="email"/>
                                <button type="submit">Subscribe</button>
                            </form>
                        </div>
                    </div> */}
                </div>
            </div>
            <div class="footer-bottom cl-white">
                <p>Copyright &copy; {moment().format("YYYY")} <a href="#0">Zigloi Support</a> - Designed by <a href="#0">Tarixel Inc</a></p>
            </div>
        </div>
    </footer>
    </div>
    )
}
